import { render, staticRenderFns } from "./paragraph-answer.vue?vue&type=template&id=794cf74e&scoped=true&"
import script from "./paragraph-answer.vue?vue&type=script&lang=js&"
export * from "./paragraph-answer.vue?vue&type=script&lang=js&"
import style0 from "./paragraph-answer.vue?vue&type=style&index=0&id=794cf74e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794cf74e",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFormLabel: require('@chakra-ui/vue').CFormLabel, CFormHelperText: require('@chakra-ui/vue').CFormHelperText, CFormControl: require('@chakra-ui/vue').CFormControl})
